import {useQuantity} from "../../../../hooks/useQuantity";
import {useMinimumQuantity} from "../../../../hooks/useMinimumQuantity";
import {useScreenSizeDetector} from "../../../../hooks/useScreenSizeDetector";
import {Button, FormControl} from "react-bootstrap";
import {FaMinus, FaPlus} from "react-icons/fa";
import * as React from "react";
import {useEffect} from "react";
import {useAppDispatch} from "../../../../redux/stateHooks";
import {setDisplayQuantity, setQuantity} from "../../../../redux/slices/addToCart";

export const QuantityInputGroup = React.memo(() => {
    const {update, displayQuantity} = useQuantity();
    const {minimumSaleQuantity} = useMinimumQuantity();
    const {isSmallScreenSize} = useScreenSizeDetector();
    const dispatch = useAppDispatch();

    // initialize redux state quantity to minimum quantity
    useEffect(() => {
        // Set quantity and display quantity to minimum quantity
        dispatch(setQuantity(minimumSaleQuantity));
        dispatch(setDisplayQuantity(minimumSaleQuantity));
    }, [minimumSaleQuantity]);

    return (
        <>
            {!isSmallScreenSize &&
                <Button variant="link"
                        onClick={() => update(displayQuantity - 1)}
                        style={{borderRadius: "0"}}
                        className={`border bg-white ${isSmallScreenSize && 'btn-sm px-1'}`}
                        disabled={displayQuantity <= minimumSaleQuantity}
                        aria-disabled={displayQuantity <= minimumSaleQuantity}
                        aria-label="Decrease Quantity">
                    <FaMinus className="text-dark" aria-hidden="true"/>
                </Button>
            }
            <FormControl
                id="quantity"
                name="addToCartQuantity"
                type="number"
                min={minimumSaleQuantity}
                value={displayQuantity}
                onChange={e => update(e.target.value)}
                style={{maxWidth: "70px"}}
                inputMode="numeric"
                className={`text-center ${isSmallScreenSize ? "" : "hide-spin-buttons"}`}
                aria-label="Quantity"
            />
            {!isSmallScreenSize &&
                <Button variant="link"
                        onClick={() => update(displayQuantity + 1)}
                        style={{borderRadius: "0"}}
                        className={`border bg-white ${isSmallScreenSize && 'btn-sm px-1'}`}
                        aria-label="Increase Quanity">
                    <FaPlus className="text-dark" aria-hidden="true"/>
                </Button>
            }
        </>
    );
})